import {SETTLEMENTDATE, ISDEMO, TOKEN} from '../cache'
import {IORDER_PATH} from '../config';
import web from './native'
import send from './send'
import axios from 'axios';
let DELETE = false;// 是否有删除权限
send({
  url: '/api/ifarm/v1/user/role_check'
}).then(ret => {
  if (ret.status === 200 && ret.data.data) {
    const data = ret.data.data;
    if (data.information_insurance === 1) {
      DELETE = true
    }
  }
});
function  getCookie(key) {
  var arr1=document.cookie.split('; ');//由于cookie是通过一个分号+空格的形式串联起来的，所以这里需要先按分号空格截断,变成[name=Jack,pwd=123456,age=22]数组类型；
  for(var i=0;i<arr1.length;i++){
    var arr2=arr1[i].split('=');//通过=截断，把name=Jack截断成[name,Jack]数组；
    if(arr2[0]===key){
      return decodeURI(arr2[1]);
    }
  }
}
export default {
  ableDelete: value => {
    if (!DELETE) {
      return false
    }
    if (typeof value === 'undefined') {
      return true
    }
    let timeStamp = SETTLEMENTDATE.timeStamp;
    let currentTimeStamp = 0;
    if (value instanceof Date) {
      currentTimeStamp = value.getTime()
    }
    if (typeof value === 'string') {
      currentTimeStamp = new Date(value.replace(/-/g, '/')).getTime()
    }
    if (typeof value === 'number') {
      return value >= timeStamp
    }
    return currentTimeStamp >= timeStamp
  },
  ableEdit: value => {
    //  月结日期
    let timeStamp = SETTLEMENTDATE.timeStamp;
    let editAuth = {}; // ableFlag 为false 为不可编辑， 原因分为两种，一种无编辑权限，一种超过月结。
    let currentTimeStamp = 0;
    if (value instanceof Date) {
      currentTimeStamp = value.getTime()
    }
    if (typeof value === 'string') {
      currentTimeStamp = new Date(value.replace(/-/g, '/')).getTime()
    }
    if (DELETE) {
      if (typeof value === 'undefined' || currentTimeStamp >= timeStamp) {
        editAuth = {
          ableFlag: true,
          ableMsg: '可以编辑'
        }
      } else {
        editAuth = {
          ableFlag: false,
          ableMsg: '当前单据状态已月结，无法进行修改!'
        }
      }
    } else {
      editAuth = {
        ableFlag: false,
        ableMsg: '您没有修改权限, 请联系管理员进行修改！'
      }
    }

    return editAuth
  },
  ableEditOld: value => {
    let timeStamp = SETTLEMENTDATE.timeStamp;
    let currentTimeStamp = 0;
    if (!DELETE) {
      return false
    }
    if (typeof value === 'undefined') {
      return true
    }
    // 无月结限制。
    if (value instanceof Date) {
      currentTimeStamp = value.getTime()
    }
    if (typeof value === 'string') {
      currentTimeStamp = new Date(value.replace(/-/g, '/')).getTime()
    }
    return currentTimeStamp > timeStamp
  },
  getMinDate() {
    return SETTLEMENTDATE.limitDate
  },
  getDefaultDate (res={},attr = 'transactionDate'){
    let pattern = new RegExp(/-/g);
    let docDate = res[attr];
    if (!docDate){
      // 当没有取到单据日期的时候，返回今天的日期。
      return new Date();
    }
    // 当有单据日期。 执行以下。
    if (pattern.test(docDate)) {
      docDate = docDate.replace(pattern,'/')
    }
    if(typeof docDate === 'string'){
      docDate = docDate.substring(0, 10)
    }
    docDate = new Date(docDate); // 订单日期
    let defaultDate = new Date();     // 当前日期，订单默认日期
    let period = res.PERIOD;          // 月结日期
    if (docDate.getTime() < defaultDate.getTime() && docDate.getTime() > period.getTime()) { // 当 订单日期 大于 月结 小于当前，则是合规的日期。
      defaultDate = docDate
    }
    if (docDate.getTime() < period.getTime()) {
      defaultDate = period
    }

    return defaultDate
  },
  scrollToBottom: (height) => {
    console.log(height);
    if (height){
      window.scrollTo(0,height)
    } else {
      window.scrollTo(0,document.getElementById('root').clientHeight)
    }
  },
  setCookie: (key, data) => {
    localStorage.setItem(key, JSON.stringify(data))
  },
  readCookie: (key) => {
    return JSON.parse(localStorage.getItem(key))
  },
  deleteCookie: () => {
    localStorage.clear()
  },
  beforeSave: () => {
    let show = false;
    if(ISDEMO) {
      show = true;
      web.callNativeModal('createDialog')
    }
    return show
  },
  setToCookie(key,value){
    document.cookie=key+'='+value;
  },
  getCookie,
  removeCookie: function (name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval=getCookie(name);
    if(cval!=null)
      document.cookie= name + '='+cval+';expires='+exp.toGMTString();
  },
  getPosition: () => {
    navigator.geolocation.getCurrentPosition( // 该函数有如下三个参数
      function(pos){ // 如果成果则执行该回调函数
        /*  console.log(
            '  经度：' + pos.coords.latitude +
            '  纬度：' + pos.coords.longitude +
            '  高度：' + pos.coords.altitude +
            '  精确度(经纬)：' + pos.coords.accuracy +
            '  精确度(高度)：' + pos.coords.altitudeAccuracy +
            '  速度：' + pos.coords.speed
          );*/
        window.lat=pos.coords.latitude;
        window.lng=pos.coords.longitude
      }, function(err){ // 如果失败则执行该回调函数
        console.log('无法获取地理位置,请打开您的定位！' + err.message,1);
      }, { // 附带参数
        enableHighAccuracy: false, // 提高精度(耗费资源)
        timeout: 1000, // 超过timeout则调用失败的回调函数
        maximumAge: 1000 // 获取到的地理信息的有效期，超过有效期则重新获取一次位置信息
      }
    );
  },
  getUserInfo: async () => {
    let userInfoRes = await axios({
      url: IORDER_PATH + '/api/iorder/v150/refresh_user_info',
      method: 'get',
      headers: {
        'x-http-appid': '1',
        'x-http-device': '0',
        'Content-Type': 'application/json',
        'Authorization': TOKEN
      }
    });
    if (userInfoRes.status === 200 && userInfoRes.data.error === 0) {
      const {uid_id, realname,tel_mobile} = userInfoRes.data.data.cp_user_info;
      const user = {
        contact: true,
        newStaff: false,
        id: uid_id,
        username: realname,
        phoneNum: tel_mobile,
        type: [
          {'label': '养殖场老板', 'value': '1', 'checked': true},
          {'label': '技术员', 'value': '37', 'checked': true},
          {'label': '业务员', 'value': '36', 'checked': true}
        ]
      };
      window.localStorage.setItem('userInfo', JSON.stringify(user));
      return {
        code: 200,
        data: user
      }
    }
    return {
      ...userInfoRes.data,
      code: 500
    }
  },
  formatMoney: (money, digit) => {
    let tpMoney = '0.00';
    if(undefined !== money){
      tpMoney = money;
    }
    tpMoney = Number(tpMoney);
    if(isNaN(tpMoney)){
      return '0.00';
    }
    tpMoney = tpMoney.toFixed(digit) + '';
    var re = /^(-?\d+)(\d{3})(\.?\d*)/;
    while(re.test(tpMoney)){
      tpMoney = tpMoney.replace(re, '$1,$2$3')
    }

    return tpMoney;
  }
}
